import { ServiceExecutionUpdateRequest } from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';
import { TimeSheetPageState } from '../../store/slices/timesheet/timesheetPageSlice';

export const handleInitialApprovalServices = (
  data: TimeSheetPageState,
): ServiceExecutionUpdateRequest[] => {
  const filteredServices: ServiceExecutionUpdateRequest[] = [];
  for (const service of data.services) {
    const { serviceExecution: serviceInstance } = service;
    filteredServices.push({
      serviceId: serviceInstance?.serviceId,
      endDateTime: serviceInstance?.endDateTime,
      isClean: serviceInstance?.isClean,
      pax: serviceInstance?.pax,
      startDateTime: serviceInstance?.startDateTime,
      isAU: serviceInstance?.isAU,
      kmsVehicles:
        serviceInstance?.kmsVehicles?.map((kv) => ({
          kmsId: kv.kmsId || undefined,
          kmsEnd: kv.kmsEnd,
          kmsIni: kv.kmsIni,
          inEmpty: kv.inEmpty,
        })) || [],
    });
  }
  return filteredServices;
};
